<template>
  <GsCascadeSelect
    :value="current"
    :options="tree"
    :placeholder="placeholder"
    :search-placeholder="searchPlaceholder"
    :clearable="clearable"
    :filterable="filterable"
    :disabled="disabled"
    :require-leaf="requireLeaf"
    @input="onInput"
    @change="onChange"
  />
</template>

<script>
import GsCascadeSelect from '@/components/GsCascadeSelect/index.vue'
import { loadRegionTree } from '@/utils/region'

export default {
  name: 'GsRegionSelect',
  components: { GsCascadeSelect },
  props: {
    value: {
      type: [Array, String],
      default: () => []
    },
    modelValue: {
      type: [Array, String],
      default: undefined
    },
    options: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择地区'
    },
    searchPlaceholder: {
      type: String,
      default: '搜索省 / 市 / 区'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /** 只允许选到区县一级（省 → 市 → 区县），默认开启 */
    requireLeaf: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loaded: []
    }
  },
  computed: {
    current() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    tree() {
      return this.options && this.options.length ? this.options : this.loaded
    }
  },
  created() {
    if (!this.options || !this.options.length) {
      loadRegionTree().then((list) => {
        this.loaded = list || []
      }).catch(() => {
        this.loaded = []
      })
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
      this.$emit('update:modelValue', val)
    },
    onChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>
